<template>
  <v-card class="mt-4">
    <v-card-title class="primary h5 text-white">{{ item.title }}</v-card-title>
    <v-card-text>
      <v-tabs v-model="tab">
        <v-tab v-for="(tab_header, index) in tabs" :key="index">
          {{ tab_header }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(content, index) in contents" :key="index">
          <div style="position: relative">
            <v-btn
              icon
              small
              class="copy-btn"
              :class="{ copying: copying, cooldown: copyCooldown }"
              :disabled="copyCooldown"
              style="
                position: absolute;
                top: 10px;
                right: 16px;
                z-index: 10;
                background-color: rgba(255, 255, 255, 0.1);
                transition: all 0.3s ease;
              "
              @click="copyToClipboard"
            >
              <v-icon small color="white" :class="{ 'copy-pulse': copying }"
                >mdi-content-copy</v-icon
              >
            </v-btn>
            <v-card
              color="basil"
              flat
              style="max-height: 400px; overflow: auto"
            >
              <v-card-text
                class="json-view-container min-h-500px"
                style="
                  background-color: #120f12 !important;
                  border-radius: 0;
                  color: white;
                  padding-top: 0;
                "
              >
                <vue-json-pretty :data="content" :showLine="false" />
              </v-card-text>
            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-snackbar v-model="snackbar" :timeout="2000" color="success">
      {{ snackbarText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "TabJson",
  components: {
    VueJsonPretty,
  },
  props: ["item"],
  data: () => ({
    tab: 0,
    snackbar: false,
    snackbarText: "",
    copying: false,
    copyCooldown: false,
  }),
  computed: {
    tabs: function () {
      return this.item.data.map((i) => i.title);
    },
    contents: function () {
      return this.item.data.map((i) => i.value);
    },
  },
  methods: {
    async copyToClipboard() {
      if (this.copyCooldown) return;

      const content = this.contents[this.tab];
      const jsonString = JSON.stringify(content, null, 2);
      await navigator.clipboard.writeText(jsonString);

      this.snackbarText = "JSON copied to clipboard";
      this.snackbar = true;

      this.copying = true;
      this.copyCooldown = true;

      setTimeout(() => {
        this.copying = false;
      }, 300);

      setTimeout(() => {
        this.copyCooldown = false;
      }, 2000);
    },
  },
};
</script>

<style scoped>
.copy-btn {
  transition: all 0.3s ease;
}

.copy-btn:hover:not(:disabled) {
  background-color: rgba(255, 255, 255, 0.25) !important;
  transform: scale(1.1);
}

.copy-btn.copying {
  transform: scale(0.9);
  background-color: rgba(76, 175, 80, 0.4) !important;
}

.copy-btn.cooldown {
  opacity: 0.5;
  cursor: not-allowed;
}

.copy-pulse {
  animation: pulse 0.3s ease;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>
